import { render, staticRenderFns } from "./Summe.vue?vue&type=template&id=160dc0ee&"
import script from "./Summe.vue?vue&type=script&lang=js&"
export * from "./Summe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports